export const acerca = {
  heading: "NOSOTROS",
  subheading: "ACERCA DE",
  description: `
      <b>HISOL</b> es una empresa <b>canadiense</b> con 10 años de experiencia en el mercado. Iniciamos operaciones en British Columbia, Canadá. Dando servicio a sectores industriales, comerciales, residenciales y de gobierno. Siempre cumpliendo con todos los estándares de calidad y seguridad vigentes.<br /><br />
      Somos una compañía dedicada al mantenimiento, restauración y limpieza de fachadas, especializados en edificios y estructuras de gran altura.<br /><br />
      A partir del año 2020 extendimos nuestras operaciones a <b>México</b>, con presencia en el bajío, centro y sureste del país para brindar nuestros servicios a las áreas comerciales e industriales de esta importante región.
    `,
  images: [
    {
      src: "./assets/imgs/poligonosHome/1.jpg",
      clipPath: "polygon(84% 60%, 18% 100%, 0 62%, 8% 30%, 46% 0, 100% 0)",
      style: {
        width: "428px",
        height: "500px",
        filter: "grayscale(100%)",
        top: "100px"
      },
    },
    {
      src: "./assets/imgs/poligonosHome/2.jpg",
      clipPath: "polygon(84% 59%, 18% 100%, 0 70%, 8% 45%, 81% 0, 100% 22%)",
      style: {
        width: "428px",
        height: "500px",
        filter: "grayscale(100%)",
        right: "0px",
        bottom: "50px"
      },
    },
    {
      src: "./assets/imgs/poligonosHome/3.jpg",
      clipPath: "polygon(100% 28%, 84% 76%, 49% 100%, 4% 100%, 0 91%, 5% 45%, 81% 0%)",
      style: {
        width: "428px",
        height: "500px",
        filter: "grayscale(100%)",
        right: "0px",
        bottom: "200px"
      },
    },
  ],
};

export const acercaEn = {
  heading: "ABOUT",
  subheading: "US",
  description: `
    <b>HISOL</b> is a Canadian company with 10 years of market experience. We began operations in British Columbia, Canada, serving industrial, commercial, residential, and government sectors, always complying with all current quality and safety standards.<br /><br />
    We are dedicated to the maintenance, restoration, and cleaning of facades, specializing in high-rise buildings and structures.<br /><br />
    Since 2020, we have expanded our operations to <b>Mexico</b>, with a presence in the Bajío, central, and southeastern regions of the country to provide our services to the commercial and industrial areas of this key region.
  `,
  images: [
    {
      src: "./assets/imgs/poligonosHome/1.jpg",
      clipPath: "polygon(84% 48%, 18% 100%, 0 62%, 8% 30%, 46% 0, 100% 0)",
      style: {
        width: "428px",
        height: "555px",
        filter: "grayscale(100%)",
        top: "100px"
      },
    },
    {
      src: "./assets/imgs/poligonosHome/2.jpg",
      clipPath: "polygon(84% 59%, 18% 100%, 0 70%, 8% 45%, 81% 0, 100% 22%)",
      style: {
        width: "428px",
        height: "555px",
        filter: "grayscale(100%)",
        right: "0px",
        bottom: "50px"
      },
    },
    {
      src: "./assets/imgs/poligonosHome/3.jpg",
      clipPath: "polygon(100% 28%, 84% 76%, 49% 100%, 4% 100%, 0 91%, 8% 56%, 81% 0%)",
      style: {
        width: "428px",
        height: "555px",
        filter: "grayscale(100%)",
        right: "0px",
        bottom: "200px"
      },
    },
  ],
};

